import { createTheme, type Theme } from "@mui/material/styles";
import { type PaletteMode } from "@mui/material";

/**
 * Module Augmentation: eigene Palettenfarbe `neutral` für den Status
 * „Ich kann nicht fahren" (grau, nicht rot) sowie `color="neutral"` an
 * Button, ToggleButton und Chip typkorrekt verfügbar machen.
 */
declare module "@mui/material/styles" {
  interface Palette {
    neutral: Palette["primary"];
  }
  interface PaletteOptions {
    neutral?: PaletteOptions["primary"];
  }
}

declare module "@mui/material/Button" {
  interface ButtonPropsColorOverrides {
    neutral: true;
  }
}

declare module "@mui/material/ToggleButton" {
  interface ToggleButtonPropsColorOverrides {
    neutral: true;
  }
}

declare module "@mui/material/Chip" {
  interface ChipPropsColorOverrides {
    neutral: true;
  }
}

const lightPalette = {
  primary: { main: "#2563eb" },
  secondary: { main: "#6a3fc8" },
  neutral: {
    main: "#5b6675",
    light: "#7c8797",
    dark: "#434c59",
    contrastText: "#ffffff",
  },
  background: {
    default: "#eef2f7",
    paper: "#ffffff",
  },
} as const;

const darkPalette = {
  primary: { main: "#5b8def" },
  secondary: { main: "#c4adf5" },
  neutral: {
    main: "#aab4c3",
    light: "#c5cdd9",
    dark: "#8591a3",
    contrastText: "#0f1622",
  },
  background: {
    default: "#0f1622",
    paper: "#192233",
  },
} as const;

/**
 * Baut das zentrale App-Theme für den gegebenen Modus (hell/dunkel).
 */
export function createAppTheme(mode: PaletteMode): Theme {
  const palette = mode === "dark" ? darkPalette : lightPalette;

  return createTheme({
    palette: {
      mode,
      ...palette,
    },
    shape: {
      borderRadius: 14,
    },
    typography: {
      fontFamily: "Roboto, system-ui, sans-serif",
      button: {
        textTransform: "none",
        fontWeight: 500,
      },
    },
  });
}
